export default __webpack_public_path__ + "static/media/pictogramBeaconFeesAndInterest48.dce9a55e.svg";